import { ChangeDetectionStrategy, Component, HostListener, input, output } from '@angular/core';

import { relativeTime } from '../../shared/utils/relative-time.util';
import { NotificacionDto } from '../domain/notifications/notification.dto';

@Component({
  selector: 'app-notification-bell',
  templateUrl: './notification-bell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationBellComponent {
  unreadCount = input(0);
  items = input<NotificacionDto[]>([]);
  open = input(false);
  loading = input(false);
  loadError = input(false);
  showChannelsLink = input(false);

  toggled = output<void>();
  itemSelected = output<NotificacionDto>();
  closed = output<void>();
  channelsLinkClicked = output<void>();

  @HostListener('document:keydown.escape')
  protected onEscape(): void {
    if (this.open()) this.closed.emit();
  }

  protected readonly relativeTime = relativeTime;
}
